import { useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import API_BASE_URL from "../config";
import { getUserId } from "../utils/Auth";

export function useChat(messagesContainerRef) {
    const [messages, setMessages] = useState([]);
    const [connection, setConnection] = useState(null);
    const [skip, setSkip] = useState(0);
    const take = 50;
    const userId = getUserId();

    // 📥 előzmények betöltése lapozva
  useEffect(() => {
    const fetchHistory = async () => {
        const token = localStorage.getItem("token");
        try {
            const res = await fetch(
                `${API_BASE_URL}/api/chat/history?skip=${skip}&take=${take}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const data = await res.json();
            if (data.success) {
                if (skip === 0) {
                    // első betöltés
                    setMessages(data.messages);
                    requestAnimationFrame(() => {
                        if (messagesContainerRef?.current) {
                            messagesContainerRef.current.scrollTop =
                                messagesContainerRef.current.scrollHeight;
                        }
                    });
                } else {
                    // régebbi üzenetek
                    const container = messagesContainerRef?.current;
                    if (!container) {
                        setMessages((prev) => [...data.messages, ...prev]);
                        return;
                    }

                    const prevHeight = container.scrollHeight;
                    const prevScroll = container.scrollTop;

                    setMessages((prev) => {
                        const existingIds = new Set(prev.map((m) => m.id));
                        const newOnes = data.messages.filter(
                            (m) => !existingIds.has(m.id)
                        );
                        return [...newOnes, ...prev];
                    });

                    requestAnimationFrame(() => {
                        const newHeight = container.scrollHeight;
                        container.scrollTop =
                            newHeight - prevHeight + prevScroll;
                    });
                }
            }
        } catch (err) {
            console.error("❌ Chat history fetch error:", err);
        }
    };
    fetchHistory();
}, [skip]);


    // 🔌 SignalR kapcsolat
    useEffect(() => {
        const conn = new signalR.HubConnectionBuilder()
            .withUrl(`${API_BASE_URL}/chathub`, {
                accessTokenFactory: () => localStorage.getItem("token") || "",
                transport: signalR.HttpTransportType.WebSockets,
                skipNegotiation: true,
            })
            .withAutomaticReconnect()
            .build();

        conn.on("ReceiveMessage", (msg) => {
            setMessages((prev) => {
                if (prev.some((m) => m.id === msg.id)) return prev;
                return [...prev, msg]; // új üzenet a végére
            });

            // új üzenetkor scroll le
            setTimeout(() => {
                if (messagesContainerRef?.current) {
                    messagesContainerRef.current.scrollTop =
                        messagesContainerRef.current.scrollHeight;
                }
            }, 50);
        });

        conn.start()
            .then(() => console.log("✅ Connected to chat"))
            .catch((err) => console.error("❌ Connection start error:", err));

        setConnection(conn);

        return () => {
            if (conn.state === signalR.HubConnectionState.Connected) {
                conn.stop();
            }
        };
    }, []);

    const sendMessage = async (text) => {
        if (!text.trim()) return;
        try {
            await connection?.invoke("SendMessage", Number(userId), text);
        } catch (err) {
            console.error("❌ SendMessage error:", err);
        }
    };

    // ⬆️ régebbi üzenetek betöltése + scroll pozíció megtartása
    const loadMore = () => {
        const container = messagesContainerRef?.current;
        if (!container) return;

        const prevHeight = container.scrollHeight;
        const prevScroll = container.scrollTop;

        setSkip((prev) => prev + take);

        setTimeout(() => {
            const newHeight = container.scrollHeight;
            container.scrollTop = newHeight - prevHeight + prevScroll;
        }, 100);
    };

    return { messages, sendMessage, loadMore, take };
}
